export default "__VITE_ASSET__BN1qijU7__"